import { useState } from "react";
import CrudTable from "../components/CrudTable";
import PDFButton from "../components/PDFButton";

const TABS = [
  { key: "advc", label: "ADVC — Manglar" },
  { key: "cert", label: "Certificado Calidad Ambiental" },
];

export default function ADVC() {
  const [tab, setTab] = useState("advc");
  return (
    <div data-testid="advc-module">
      <div className="flex items-center justify-between mb-3">
        <h1 className="card-h1" style={{ margin: 0 }}>Compromisos Voluntarios (ADVC)</h1>
        <PDFButton endpoint="/pdf/module/racs" filename="reporte_advc.pdf" label="Reporte PDF" />
      </div>
      <div className="tabs-bar">
        {TABS.map((t) => <button key={t.key} className={`tab ${tab === t.key ? "active" : ""}`} onClick={() => setTab(t.key)} data-testid={`advc-tab-${t.key}`}>{t.label}</button>)}
      </div>
      {tab === "advc" && (
        <CrudTable
          collection="advc_records"
          filters={{ category: "ADVC_Manglar" }}
          testIdPrefix="advc"
          fields={[
            { key: "record_type", label: "Tipo", type: "select", options: ["Recorrido vigilancia", "Actividad ilícita", "Inspección señalética", "Detección amenazas", "Cámara trampa", "Especie NOM-059", "Limpieza senderos", "Rescate de flora"] },
            { key: "date", label: "Fecha", type: "date" },
            { key: "description", label: "Descripción", type: "textarea", full: true },
            { key: "personnel", label: "Personal" },
            { key: "findings", label: "Hallazgos", type: "textarea", full: true },
            { key: "species_name", label: "Especie (si aplica)" },
            { key: "category", label: "Categoría", default: "ADVC_Manglar", hidden: true, hiddenInForm: true },
            { key: "status", label: "Status", type: "select", options: ["Programado", "Ejecutado", "Cerrado"] },
          ]}
        />
      )}
      {tab === "cert" && (
        <CrudTable
          collection="advc_records"
          filters={{ category: "Certificado" }}
          testIdPrefix="cert"
          fields={[
            { key: "record_type", label: "Tipo" },
            { key: "date", label: "Fecha", type: "date" },
            { key: "description", label: "Descripción", type: "textarea", full: true },
            { key: "category", label: "Categoría", default: "Certificado", hidden: true, hiddenInForm: true },
            { key: "status", label: "Status", type: "select", options: ["Pendiente", "Vigente", "Vencido"] },
          ]}
        />
      )}
    </div>
  );
}
